import ky from 'ky'
import { createSignal, onCleanup, type Accessor } from 'solid-js'

const TICK_INTERVAL_MS = 1_000
const RESYNC_INTERVAL_MS = 60_000

// The Shop server clock (GLOSSARY.md): the one signal feeding every domain
// time judgment — sale windows today, the featured countdowns and rollover
// later. Seeded from the `ts` launch param, advanced locally every second,
// and re-anchored from `/time.js?`, whose redirect's final URL carries
// `?ts=<unix seconds>` (the pass-event-paywall / focus-pass timestamp
// pattern), so a long session cannot drift. A failed resync keeps the last
// anchor ticking.
export function createServerClock(seedMs: number): Accessor<number> {
  let anchorServerMs = seedMs
  let anchorLocalMs = Date.now()
  const [nowMs, setNowMs] = createSignal(seedMs)
  const tick = () => setNowMs(anchorServerMs + (Date.now() - anchorLocalMs))
  const resync = async () => {
    try {
      const response = await ky.get('/time.js?')
      const ts = Number(new URL(response.url).searchParams.get('ts'))
      if (!Number.isFinite(ts) || ts <= 0) return
      anchorServerMs = ts * 1000
      anchorLocalMs = Date.now()
      tick()
    } catch {
      // Keep ticking from the previous anchor.
    }
  }
  const tickTimer = setInterval(tick, TICK_INTERVAL_MS)
  const resyncTimer = setInterval(() => void resync(), RESYNC_INTERVAL_MS)
  onCleanup(() => {
    clearInterval(tickTimer)
    clearInterval(resyncTimer)
  })
  return nowMs
}
